<template>
  <div class="page">
    <problem-list ref="problem-List" :taskList="taskList" />
  </div>
</template>

<script>
import ProblemList from "./components/problemList.vue";
export default {
  components: { ProblemList },
  data() {
    return {
      taskList: [
        { taskId: "Activity_00011zf", taskName: "问题审核" },
        { taskId: "Activity_1m3u00z", taskName: "措施审批" },
        { taskId: "Activity_0627lvf", taskName: "措施确认" },
        { taskId: "Activity_1kbk3hf", taskName: "措施验证" },
        { taskId: "Activity_0a0691e", taskName: "根因分析-上传材料" },
        { taskId: "Activity_15dcx2n", taskName: "永久方案-市场验证" },
        { taskId: "Activity_0fsewki", taskName: "永久方案-市场关闭" }
      ]
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
